export function exportXML(params: any, bpmnjs: any) {
    return {
        args: [
        ],
        exec: async () => {
            const ret = { result: null, error: null } as BpmnExportResult;
            try {
                const { xml } = await bpmnjs.saveXML({ format: true });
                ret.result = xml;
            } catch (err) {
                ret.error = err;
            }

            return ret;
        }
    };
}
exportXML.$inject = ["cli._params", "bpmnjs"];
